import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { EpicWithThunk } from 'state/state.common';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';
export function requestScheduledRunsEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { getRuns } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_RUNS_REQUESTED'),
      mergeMap(({ id }) => {
        return getRuns().pipe(
          map(runs => scheduledRunActions.scheduledRunRunsReceived(id, runs)),
          catchError((err: HttpError) =>
            of(scheduledRunActions.scheduledRunRunsFailed(id, toTypedError('Pricing Runs DIY', err))),
          ),
        );
      }),
    );
  };
}
